export default "__VITE_ASSET__9e42ea13__"